<div class="d-flex flex-row justify-content-between align-items-center mb-2">

  <div mat-button *ngIf="isHodnotenie(message)" class="message" i18n-title title="Zobraziť detail hodnotenia" (click)="openDetailHodnotenia(message)">
    <a class="text-decoration-none">{{message.casVzniku | date:'dd.MM.yyyy HH:mm'}} - {{message.text}}</a>
  </div>

  <div mat-button *ngIf="isPredpisPlatby(message)" class="message" i18n-title title="Príkaz na úhradu" (click)="poplatokAction(message)">
    <a class="text-decoration-none">{{message.casVzniku | date:'dd.MM.yyyy HH:mm'}} - {{message.text}}</a>
    <mat-spinner *ngIf="loading" [diameter]="20"></mat-spinner>
  </div>

  <div mat-button *ngIf="isTerminHodnotenia(message)" class="message" i18n-title title="Zobraziť detail termínu" (click)="terminHodnoteniaAction(message)">
    <a class="text-decoration-none">{{message.casVzniku | date:'dd.MM.yyyy HH:mm'}} - {{message.text}}</a>
    <mat-spinner *ngIf="loading" [diameter]="20"></mat-spinner>
  </div>

  <div mat-button *ngIf="isNastenka(message)" class="message" i18n-title title="Zobraziť detail" (click)="detailNastenkaAction(message)">
    <a class="text-decoration-none">{{message.casVzniku | date:'dd.MM.yyyy HH:mm'}} - {{message.text}}</a>
    <mat-spinner *ngIf="loading" [diameter]="20"></mat-spinner>
  </div>

  <div mat-button *ngIf="isDiskusneForum(message)" class="message" i18n-title title="Zobraziť detail" (click)="detailForumAction(message)">
    <a class="text-decoration-none">{{message.casVzniku | date:'dd.MM.yyyy HH:mm'}} - {{message.text}}</a>
    <mat-spinner *ngIf="loading" [diameter]="20"></mat-spinner>
  </div>

  <div *ngIf="!isHodnotenie(message) && !isPredpisPlatby(message) && !isTerminHodnotenia(message) && !isNastenka(message) && !isDiskusneForum(message)">

    <button *ngIf="message.download" mat-menu-item (click)="fileSave(message)">
      <a class="text-decoration-none">{{message.casVzniku | date:'dd.MM.yyyy HH:mm'}} - {{message.text}} <span class="material-icons small">file_download</span></a>
    </button>

    <div mat-button *ngIf="!message.download && !message.aplikaciaUrl" class="message" i18n-title title="Zobraziť ďalšie možnosti">
      {{message.casVzniku | date:'dd.MM.yyyy HH:mm'}} - {{message.text}}
    </div>

    <div mat-button *ngIf="!message.download && message.aplikaciaUrl" [matMenuTriggerFor]="menu" class="message" i18n-title title="Zobraziť ďalšie možnosti">
      <a class="text-decoration-none">{{message.casVzniku | date:'dd.MM.yyyy HH:mm'}} - {{message.text}}</a>
    </div>

  </div>

  <div>
    <button (click)="delete(message)" mat-icon-button i18n-aria-label aria-label="Zmazať notifikáciu" i18n-title title="Zmazať notifikáciu">
      <mat-icon>delete_outline</mat-icon>
    </button>
  </div>
</div>

<mat-menu #menu="matMenu">
  <button *ngIf="message.aplikaciaUrl" mat-menu-item class="small" (click)="appOpen(message)">
    <mat-icon>fiber_manual_record</mat-icon>
    <span i18n>Otvoriť aplikáciu</span>
  </button>
</mat-menu>
